import { setNotification } from "features/Notification/notificationSlice";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import useInbox from "../../InboxTab/InboxContext";
import EmailDetailHeader from "./EmailDetailHeader";
import EmailDetailsWrapper from "./EmailDetailsWrapper";
import Spinner from "components/Spinner";

export default function EmailDetailsStructure() {
  const dispatch = useDispatch();
  /* ******************** All States ************************* */
  const { messageId } = useInbox();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  /* ******************** All Functions ************************* */
  const getMessageById = useCallback(
    async (selectedMessage) => {
      try {
        setLoading(true);
        const { data } = await API.post(
          `/emails/message`,
          {
            messageId: selectedMessage,
          },
          {
            headers: authHeader(),
          },
        );

        if (data?.success) {
          setMessage(data?.email);
          // setCompanyEmail(data?.companyEmail || null);
        } else {
          dispatch(
            setNotification({
              type: "error",
              message: data?.message || "Failed to fetch email details.",
            }),
          );
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        dispatch(
          setNotification({
            type: "error",
            message: error.message,
          }),
        );
      }
    },
    [messageId],
  );

  /* ******************** All UseEffects ************************* */

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (messageId) {
        console.log(messageId);
        getMessageById(messageId);
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [messageId]);

  return (
    <div>
      {loading && <Spinner />}
      {/* ******************** Email Header with Actions ************************* */}
      <EmailDetailHeader
        message={message}
        setMessage={setMessage}
        refreshFunc={getMessageById}
      />
      <hr className="mt-0 " />
      {/* ******************** Email Body ************************* */}
      <div
        className="bg-light px-3 py-3 rounded-3 mx-2"
        style={{
          overflowY: "auto",
          height: messageId ? "88vh" : "67vh",
        }}
      >
        <div className="flex-grow-1">
          {message && (
            <EmailDetailsWrapper
              message={message}
              refreshFunc={getMessageById}
            />
          )}
        </div>
      </div>
    </div>
  );
}
